import { Link } from "react-router-dom";
import { HeartPulse, Sparkles, Baby, Bone, Brain, Flower2, Stethoscope, Ear, Eye, Smile } from "lucide-react";

const ITEMS = [
  { name: "Cardiology", desc: "Heart & cardiovascular care", icon: HeartPulse },
  { name: "Dermatology", desc: "Skin, hair & aesthetics", icon: Sparkles },
  { name: "Pediatrics", desc: "Child & newborn care", icon: Baby },
  { name: "Orthopedics", desc: "Bone, joint & sports injuries", icon: Bone },
  { name: "Neurology", desc: "Brain & nervous system", icon: Brain },
  { name: "Gynecology", desc: "Women's health & pregnancy", icon: Flower2 },
  { name: "General Physician", desc: "Primary care & diagnostics", icon: Stethoscope },
  { name: "ENT", desc: "Ear, nose & throat", icon: Ear },
  { name: "Ophthalmology", desc: "Eye & vision care", icon: Eye },
  { name: "Dentistry", desc: "Oral & dental care", icon: Smile },
];

export default function Specialties() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Medical Specialties</h1>
      <p className="mt-2 max-w-2xl text-slate-600">Browse by specialty and connect with verified doctors across India.</p>
      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {ITEMS.map((s) => (
          <Link key={s.name} to={`/doctors?specialty=${encodeURIComponent(s.name)}`} className="card group flex items-start gap-4 p-6">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-700 transition-colors group-hover:bg-blue-700 group-hover:text-white">
              <s.icon className="h-6 w-6" />
            </div>
            <div>
              <div className="font-bold text-slate-900">{s.name}</div>
              <div className="mt-1 text-sm text-slate-600">{s.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
